<template>
    <div class="l-link-preview">
        <div class="preview-container clickable" data-test-id="preview-link" @click="openLink">
            <div class="preview-info">
                <div class="preview-title ellipsis" data-test-id="preview-title">{{ title }}</div>
                <div class="preview-description ellipsis" data-test-id="preview-description">
                    {{ description }}
                </div>
            </div>
            <div class="preview-image">
                <img
                    data-test-id="preview-image"
                    :src="image || defaultPreviewImage"
                    :alt="title"
                />
            </div>
        </div>
    </div>
</template>

<script>
import defaultPreviewImage from "@/img/icons/link-preview/default-image.svg";

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {
            defaultPreviewImage,
        };
    },
    methods: {
        openLink() {
            window.open(this.url, "_blank", "noopener noreferrer");
        },
    },
};
</script>

<style scoped>
.preview-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border: 2px solid var(--color-grey-light);
    border-radius: 0.75rem;
}
.preview-container:hover {
    background-color: #f9f9f9;
    transition: all 200ms ease-in-out;
}

.preview-info {
    flex-grow: 1;
    width: calc(100% - 140px);
}
.preview-title {
    font-weight: bold;
}
.preview-description {
    color: var(--color-grey);
}

.preview-image img {
    width: 140px;
    padding-left: 2.5rem;
}
</style>
